/* eslint max-len: 0 */
import React from 'react';

export const ArrowSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7633 5.01332C11.7633 5.42753 11.4275 5.76332 11.0133 5.76332L1.01997 5.76332C0.605759 5.76332 0.269972 5.42753 0.269972 5.01332C0.269972 4.59911 0.605759 4.26332 1.01997 4.26332L11.0133 4.26332C11.4275 4.26332 11.7633 4.59911 11.7633 5.01332Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.54252 9.53755C5.25007 9.83088 4.77519 9.83159 4.48186 9.53913L0.461863 5.53113C0.320634 5.39032 0.241301 5.19907 0.2414 4.99964C0.241499 4.80021 0.321023 4.60903 0.462392 4.46836L4.48906 0.461695C4.78268 0.169531 5.25755 0.170713 5.54972 0.464334C5.84188 0.757957 5.8407 1.23283 5.54708 1.52499L2.05418 5.00054L5.54094 8.47689C5.83427 8.76934 5.83498 9.24422 5.54252 9.53755Z"
      fill="currentColor"
    />
  </svg>
);
